{
    "onsite_scanning": {
        "actions": {
            "final": "Final",
            "pre_printed": "Pre-printed",
            "preview_as_user": "Preview as a user",
            "preview_download": "Preview & Download",
            "printed_onsite": "Printed onsite",
            "reset_check_in_data": "Reset check-in data",
            "reset_event_check_in_data": "Reset event check-in data",
            "reset_event_check_in_data_confirm": "Are you sure you want to reset all the event check-in data for this event?",
            "reset_event_check_in_data_description": "By this option you can reset the event check-in data for all users. Note: This may have an impact on how data appears in your attendance tracking report.",
            "reset_event_check_in_data_success": "Check-in reset complete",
            "reset_event_check_in_data_warning": "This may have an impact on how data appears in your attendance tracking report. This action is permanent and cannot be undone.",
            "title": "Actions"
        },
        "badge_editor": {
            "add_background_note": "Go to the Assets library in order to upload the images.",
            "add_text": "Add a text",
            "add_text_note": "Use the double brackets {{}} to insert metadata, eg. {{fname}}",
            "background_panel_title": "Background Image",
            "bottom": "Align bottom",
            "center": "Align vertical center",
            "duplicate": "Duplicate",
            "flip_horizontal": "Flip horizontal",
            "flip_vertical": "Flip vertical",
            "font_color": "Font color",
            "image_panel": "Image",
            "image_panel_note": "Go to the Assets library in order to upload the images.",
            "image_panel_printer_alert": "The Zebra ZD621 printer can only print in black. Please only use black images.",
            "left": "Align left",
            "middle": "Align horizontal center",
            "mismatched_dimensions": "Please upload a background image sized exactly {0} px and exported in CMYK color mode. The current file does not meet these requirements and will affect badge printing quality and color accuracy.",
            "parameters": {
                "arrangement": "Arrangement",
                "custom_rotation": "Custom rotation",
                "dimension": "Dimensions",
                "height": "Height",
                "max_font_size": "Font size",
                "min_font_size": "Minimum font size",
                "min_font_size_tip": "Minimum size text can shrink to when adjusting for longer content",
                "position": "Position",
                "size": "Size",
                "text_alignment": "Text alignment",
                "tools": "Tools",
                "width": "Width"
            },
            "preview_modal": {
                "alert": {
                    "message": "{0}: This contains information unique to this person and their account - their unique QR code.",
                    "title": "Do not share"
                },
                "preview": "Preview",
                "select_user": "Select user",
                "sub_title": "Choose a user to see how their badge will look.",
                "title": "Preview badge design as a user"
            },
            "qr_code_panel": "QR code",
            "qr_content": "QR code value",
            "right": "Align right",
            "rotate_90_left": "Rotate 90º left",
            "save_failed": "Badge design save failed.",
            "save_successful": "Badge design has been saved.",
            "select_font": "Select Font",
            "select_image": "Select Image",
            "text_panel": "Text",
            "top": "Align top",
            "upload_font_note": "Go to the Assets library in order to upload fonts.",
            "warn_unsaved_changes": "You have unsaved changes. Discard them and leave this page?",
            "zd621_color_tooltip": "Zebra ZD621 printer supports black text only (#000000)"
        },
        "design": {
            "layout_dpi": "Dots per inch",
            "layout_height": "Page layout height",
            "layout_name": "Design name",
            "layout_preset": "Badge type",
            "layout_unit": "Page format unit",
            "layout_width": "Page layout width",
            "messages": {
                "bg_not_fitting": "Please provide an image with a resolution of {0}x{1} px for an optimal result."
            }
        },
        "settings": {
            "admin_pin": {
                "error": "The PIN is insecure. Avoid using repeating or sequential digits",
                "hint": "Choose a 4-digit PIN to secure the admin panel on the tablet app.",
                "label": "Set up the admin PIN code"
            },
            "background_color": {
                "label": "Background color",
                "tip": "If the uploaded background image cannot be used, the chosen fill color will be used instead."
            },
            "bg": {
                "hint": "Recommended size: 2732x2048px",
                "label": "Background"
            },
            "buttons": {
                "primary_button_text_color": {
                    "label": "Primary button icon"
                },
                "secondary_button_background_color": {
                    "label": "Secondary button background",
                    "tip": "Secondary buttons are visible even on tables with a default white background. Please choose a color that remains effective in this scenario as well."
                },
                "secondary_button_text_color": {
                    "label": "Secondary button text"
                }
            },
            "checkin": {
                "admin_pin": "Admin PIN",
                "attendee": "Attendee check-in",
                "exception": "Exception desk check-in",
                "general_settings": "General settings",
                "host": "Host check-in"
            },
            "general": {
                "note": "Settings in this section will count for all 3 check-in modes: kiosk, host and exception desk.",
                "signature_collection": {
                    "label": "Signature collection",
                    "note": "Participants must provide their signature before completing check-in and badge printing."
                }
            },
            "layout": {
                "label": "Background image"
            },
            "logo": {
                "hint": "Recommended size: 600x120px for horizontal, 300x300px for square and 150x600 for vertical logos",
                "label": "Logo"
            },
            "messages": {
                "save_failure": "Could not save the settings. Try again later or contact the support.",
                "save_failure_required_fields": "The form submitted is invalid. Please verify the form fields for errors.",
                "save_success": "Settings successfully updated."
            },
            "metadata_display_fields": {
                "label": "Metadata to display on the list"
            },
            "metadata_match": {
                "label": "Search method"
            },
            "metadata_printing": {
                "label": "Metadata to be displayed on the check-in verification screen"
            },
            "metadata_search_fields": {
                "label": "Metadata to search by"
            },
            "printer": {
                "add_design": "Add another design",
                "badge_design": "Badge design",
                "designs": {
                    "label": "Default badge design|Badge design {0}",
                    "section_removal": "Are you sure you want to delete this section?",
                    "section_removal_title": "Delete badge design reference"
                },
                "not_visible_desc": "Participants matching these rules will be excluded for badges printed using this code",
                "not_visible_label": "Not used for",
                "pax_print_quantity": {
                    "hint": "Exception desk can always reprint attendees' badges and is not limited by this setting",
                    "label": "Number of badges that can be printed per attendee"
                },
                "pick_design": "Select a design",
                "printer_kind": {
                    "label": "Choose your type of printer"
                },
                "skip_printing": {
                    "label": "Allow to skip badge printing in the kiosk"
                },
                "visible_desc": "Participants matching these rules will be included for badges printed using this code",
                "visible_label": "Used for"
            },
            "printing_enabled": {
                "label": "Badge printing"
            },
            "scanning_enabled": {
                "label": "Scan QR code"
            },
            "search_enabled": {
                "label": "Search"
            },
            "text_color": {
                "label": "Text color"
            }
        }
    }
}
